export const CaViewerType = [
  'customer',
  'staff'
];
